import { ModuleList } from '../../../../../shared/analytics/module-list';
import { pagesConfig } from '../../../../../shared/pages-config';
import SimpleBreadcrumbsPage from '../../../../../shared/simple-breadcrumbs-page';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function GpanelContactsSyncFormSkeleton() {
  return (
    <SimpleBreadcrumbsPage
      isSubPage
      breadcrumbs={[
        { label: ModuleList.modules.directory.name },
        {
          label: pagesConfig.gpanelContacts.name,
          path: pagesConfig.gpanelContacts.link,
        },
      ]}
    >
      <Stack
        flexDirection="column"
        gap={1}
        sx={{
          minHeight: 420,
          overflow: 'hidden',
          flexGrow: 1,
          height: 'calc(100vh - 150px)',
        }}
      >
        <Card
          sx={{
            width: '100%',
            minHeight: 300,
            overflow: 'auto',
            display: 'flex',
            height: '100%',
          }}
        >
          <Stack
            flexDirection="column"
            justifyContent="start"
            alignItems="start"
            sx={{
              height: '100%',
              overflow: 'hidden',
              flexGrow: 1,
              pr: 1,
            }}
          >
            <DialogTitle
              sx={{
                position: 'relative',
                alignSelf: 'center',
                mt: 2,
              }}
              whiteSpace={'nowrap'}
              textOverflow={'ellipsis'}
              overflow={'hidden'}
            >
              <Skeleton
                variant="rounded"
                width={300}
                height={25}
                sx={{ mb: 1 }}
              />
              <Box
                sx={{
                  width: '96px',
                  height: '2px',
                  backgroundColor: 'primary.main',
                  mx: 'auto',
                }}
              ></Box>
            </DialogTitle>
            <Stack
              direction="column"
              sx={{ width: '100%', overflowY: 'auto', flexGrow: 1 }}
            >
              <Container
                sx={{
                  pt: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  flexGrow: 0,
                }}
              >
                <Grid container spacing={3} sx={{ ml: 7 }}>
                  <Grid size={5}>
                    <Skeleton variant="rounded" width={400} height={40} />
                  </Grid>
                  <Grid size={5}>
                    <Skeleton variant="rounded" width={400} height={40} />
                  </Grid>
                  <Grid size={10}>
                    <Skeleton variant="rounded" width={400} height={40} />
                  </Grid>
                  <Grid size={5}>
                    <Skeleton variant="rounded" width={400} height={40} />
                  </Grid>
                  <Grid size={5} alignContent={'center'}>
                    <Stack flexDirection={'row'} mt={0.5}>
                      <Skeleton
                        variant="rounded"
                        width={20}
                        height={20}
                        sx={{ ml: 1 }}
                      />
                      <Skeleton
                        variant="rounded"
                        width={150}
                        height={20}
                        sx={{ ml: 1 }}
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Stack
                  sx={{
                    width: '100%',
                    overflow: 'hidden',
                    flexGrow: 1,
                    mt: 3,
                  }}
                >
                  <Stack
                    flexDirection={'row'}
                    gap={4}
                    alignItems={'center'}
                    justifyContent="center"
                    mt={8}
                  >
                    <Stack
                      flexDirection={'column'}
                      alignItems={'center'}
                      gap={1}
                    >
                      <Skeleton variant="rounded" width={90} height={20} />
                      <Skeleton variant="rounded" width={500} height={20} />
                      <Skeleton
                        variant="rounded"
                        width={380}
                        height={25}
                        sx={{ mb: 1 }}
                      />
                    </Stack>
                  </Stack>
                  <Stack flexDirection={'row'} gap={1}>
                    <Skeleton variant="rounded" width="100%" height={500} />
                  </Stack>
                </Stack>
              </Container>
            </Stack>
            <Stack
              flexDirection="row"
              justifyContent="space-between"
              sx={{ width: '100%', p: 4, mt: 'auto', flexBase: 0 }}
              alignSelf="end"
            >
              <Button
                variant="outlined"
                color="primary"
                disabled
                sx={{ mr: 1 }}
              >
                Cancel
              </Button>
              <Button variant="contained" color="primary" disabled>
                Update Sync
              </Button>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    </SimpleBreadcrumbsPage>
  );
}
